/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import PropTypes from "prop-types";
import {
	Box,
	Grid,
	Button,
	Modal,
	Tooltip,
	IconButton,
	Divider,
} from "@mui/material";
import Card, {
	ButtonWrapper,
	LoaderWrapper,
} from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import ComboHeader from "../../components/ComboHeader/ComboHeader";
import Kpi from "../../components/KPI/Kpi";
import utils from "../../QlikUtils";
import ObjectLoader from "../../components/ObjectLoader/ObjectLoader";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CloseIcon from "@mui/icons-material/Close";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import CircleLoader from "../../components/Loaders/CircleLoader";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import Bar from "../../components/Bar/Bar";

function OpportunitiesMobile({ app, config }) {
	const configData = config?.sellOutArea ?? null;
	const [openReports, setOpenReports] = useState(false);
	const [loading, setLoading] = useState(true);
	const [loadingExcel, setLoadingExcel] = useState(false);

	const initializeRows = async (id, card) => {
		await utils.createHyperCubeByQlikIdToTable(app, id, 35, (res) => {
			card.rows = utils
				.extractDataSet(res)
				.slice(1)
				.map((item) => {
					return {
						name: item[0].value,
						scoreValue: parseInt(item[1].value),
						goalValue: parseInt(
							item[2].value.slice(2, -3).replace(/\./g, "")
						),
						value: parseInt(
							item[3].value.slice(2, -3).replace(/\./g, "")
						),
					};
				});
			const a = card.rows
				.map((e) => Math.max(e.value, e.goalValue))
				.reduce(function (prev, current) {
					return Math.max(prev, current);
				});
			card.highestValue = a;
			const roundedUpScale =
				Math.round(a / 10 ** (a.toString().length - 1)) *
				10 ** (a.toString().length - 1);
			card.scale = [0, roundedUpScale / 2, roundedUpScale];
			setTimeout(() => {
				setLoading(false);
			}, 1200);
		});
	};

	const exportToXLS = async (objectId) => {
		setLoadingExcel(false);
		let id = objectId;

		if (app && id) {
			setLoadingExcel(true);
			await app.visualization
				.get(id)
				.then((vis) => {
					vis.table
						.exportData({ format: "OOXML", state: "A" })
						.then((link) => {
							setLoadingExcel(false);
							const xlsLink = `https://qsense.mtrix.com.br${
								process.env.REACT_APP_PREFIX
							}${link.substring(link.indexOf("tempcontent"))}`;
							window.open(xlsLink);
						});
				})
				.catch(() => setLoadingExcel(false));
		}
	};

	const getColorFromPercentage = (percentage) => {
		switch (true) {
			case percentage < 85:
				return "#E95248";
			case percentage < 100:
				return "#FDB949";
			default:
				return "#38BC9A";
		}
	};

	for (const card of configData.cards) {
		card.value = Kpi({
			app,
			objectId: card.nativeObject.valueId,
			updatesWithSelection: true,
		});
		card.goalValue = Kpi({
			app,
			objectId: card.nativeObject.goalValueId,
			updatesWithSelection: true,
		});
		card.remainingValue = Kpi({
			app,
			objectId: card.nativeObject.remainingValueId,
			updatesWithSelection: true,
		});
		card.percentage = Kpi({
			app,
			objectId: card.nativeObject.percentageId,
			updatesWithSelection: true,
		});

		initializeRows(card.nativeObject.rankingTableId, card);

		const num = parseInt(card.percentage?.slice(0, -1)) ?? 0;
		card.percentageNum = num > 100 ? 100 : num;
		card.percentageColor = getColorFromPercentage(card.percentageNum);
	}

	return (
		<div className="app sellOutArea">
			<div className="appContent">
				<LayoutWrapper>
					<Grid
						container
						flexDirection={"column"}
						justifyContent="space-between"
						alignItems={"center"}
						rowGap={2}
					>
						{/* TITLE */}
						<Grid
							item
							container
							flexDirection={"row"}
							justifyContent={"flex-end"}
							alignItems={"center"}
						>
							<Grid className="detailButton" item>
								{openReports ? (
									<Grid
										item
										container
										flexDirection="row"
										justifyContent="flex-end"
										alignItems="flex-start"
										xs
									>
										<Tooltip title="Exportar para Excel">
											<IconButton
												type="button"
												onClick={() =>
													exportToXLS(
														"50470d3d-02ea-45e9-b914-94aac1ae0e1a"
													)
												}
											>
												{!loadingExcel ? (
													<ExitToAppIcon />
												) : (
													<LoaderWrapper>
														<CircleLoader />
													</LoaderWrapper>
												)}
											</IconButton>
										</Tooltip>
										<Tooltip title="Fechar">
											<IconButton
												type="button"
												onClick={() =>
													setOpenReports(false)
												}
											>
												<CloseIcon />
											</IconButton>
										</Tooltip>
									</Grid>
								) : (
									<Button
										variant="text"
										endIcon={<OpenInNewIcon />}
										onClick={() => setOpenReports(true)}
									>
										<Box component={"span"}>Relatórios</Box>
									</Button>
								)}
							</Grid>
						</Grid>

						{/* CARDS */}
						{openReports ? (
							<Grid
								item
								sx={{
									width: "100%",
									height: "100%",
								}}
								xs
							>
								<Card
									app={app}
									header={{
										hardTitle: "Relatórios",
									}}
									sx={{
										height: "100%",
										width: "100%",
									}}
								>
									<Grid
										item
										sx={{
											minWidth: "100%",
											height: "100%",
											minHeight: "76vh",
										}}
										xs
									>
										<NativeObject
											app={app}
											key="50470d3d-02ea-45e9-b914-94aac1ae0e1a"
											type={"table"}
											reference={{
												id: "50470d3d-02ea-45e9-b914-94aac1ae0e1a",
											}}
											style={{
												padding: "0 12px ",
											}}
										/>
									</Grid>
								</Card>
							</Grid>
						) : (
							<Grid
								item
								container
								flexDirection={"row"}
								justifyContent="space-between"
								rowGap={2}
								xs
								sx={{
									width: "100%",
								}}
							>
								{configData?.cards.map((card, index) => (
									<Grid
										key={index}
										item
										xs={12}
										sx={{
											minHeight: "80vh",
										}}
									>
										<Card
											app={app}
											header={{
												hardTitle: card.title.hardTitle,
											}}
										>
											<Grid
												className={`sell-out-wrapper ${
													index === 0
														? ""
														: " bordered"
												}`}
												container
												flexDirection="column"
												justifyContent="space-between"
												rowGap={4}
												sx={{
													height: "100%",
												}}
											>
												{/* KPI PROGRESS BAR  */}
												<Grid
													container
													flexDirection="row"
													justifyContent="space-between"
													alignItems="flex-start"
													columnGap={4}
												>
													{/* KPI */}
													<Grid
														container
														item
														xs={12}
														flexDirection="column"
														justifyContent="flex-start"
														alignItems="flex-start"
														rowGap={1}
													>
														<Grid
															className={`value-wrapper`}
															container
															item
															xs={12}
															flexDirection="column"
															justifyContent="flex-start"
															alignItems="flex-start"
														>
															{/* VALUE */}
															<Grid
																container
																item
																flexDirection="row"
																justifyContent="flex-start"
																alignItems="flex-end"
																style={{
																	width: "100%",
																	height: "50%",
																	marginBottom:
																		"4px",
																}}
															>
																<Box
																	component="span"
																	className="value"
																	style={{
																		color: card.percentageColor,
																	}}
																>
																	{card.value}
																</Box>
															</Grid>

															{/* PROGRESS BAR */}
															<Grid
																container
																flexDirection="column"
																justifyContent="flex-start"
																alignItems="flex-start"
																style={{
																	width: "100%",
																}}
															>
																<ProgressBar
																	key={
																		card
																			.title
																			.hardTitle
																	}
																	bgColor={
																		card.percentageColor
																	}
																	completed={
																		card.percentageNum
																	}
																/>
															</Grid>
														</Grid>
														{/* GOAL AND PERCENTAGE */}
														<Grid
															container
															item
															flexDirection="row"
															justifyContent="flex-start"
															alignItems="flex-start"
															xs
															columnGap={1}
														>
															{/* GOAL VALUE */}
															<Grid
																className={`goal-wrapper`}
																container
																item
																flexDirection="row"
																justifyContent="flex-start"
																alignItems="center"
																columnGap={0.8}
																xs
															>
																<Grid item xs>
																	{/* VALOR EM CINZA */}
																	<Box
																		component="span"
																		className="goal-value"
																	>
																		{
																			card.goalValue
																		}
																	</Box>
																</Grid>
																<Grid item xs>
																	<Box
																		component="span"
																		className="goal-text"
																	>
																		Meta
																	</Box>
																</Grid>
															</Grid>

															{/* GOAL PERCENTAGE */}
															<Grid
																className={`percentage-wrapper`}
																container
																item
																flexDirection="row"
																justifyContent="flex-start"
																alignItems="center"
																columnGap={0.8}
																xs
															>
																<Grid item>
																	<Box
																		component="span"
																		className="percentage-value"
																		style={{
																			color: card?.percentageColor,
																		}}
																	>
																		{
																			card?.percentage
																		}
																	</Box>
																</Grid>
																<Grid item>
																	<Box
																		component="span"
																		className="percentage-text"
																	>
																		Ating.
																	</Box>
																</Grid>
															</Grid>
														</Grid>
													</Grid>
												</Grid>

												{/* RANKING */}
												<Grid
													container
													flexDirection="column"
													justifyContent="space-between"
												>
													<Grid item xs>
														<ComboHeader
															reference={{
																title: {
																	hard: `Ranking ${
																		index ===
																		0
																			? "Geral"
																			: ""
																	}`,
																},
															}}
															scale
															legends={[
																{
																	type: "bar",
																	iconColor:
																		"#F98561",
																	name: "Meta",
																},
																{
																	type: "bar",
																	iconColor:
																		"#55B6EB",
																	name: "Realizado",
																},
															]}
														/>
													</Grid>
													{loading ? (
														<ObjectLoader
															icon="table"
															height="inherit"
															width="inherit"
														/>
													) : (
														<Grid
															container
															flexDirection="column"
															justifyContent="center"
															alignItems="flex-start"
															rowGap={1}
														>
															<Grid
																container
																item
																flexDirection="row"
																justifyContent="flex-start"
																sx={{
																	maxHeight:
																		"44vh",
																	overflowY:
																		"scroll",
																}}
																xs={12}
															>
																<Grid
																	container
																	item
																	flexDirection="column"
																	justifyContent="center"
																	rowGap={2}
																	alignItems="center"
																	sx={{
																		height: "100%",
																		margin: "0 8px 0 4px",
																	}}
																	xs={12}
																>
																	{card?.rows
																		?.length
																		? card.rows?.map(
																				(
																					row,
																					index
																				) => (
																					<Grid
																						key={
																							index
																						}
																						container
																						item
																						flexDirection="column"
																						justifyContent="center"
																						alignItems="flex-start"
																						xs={
																							12
																						}
																						rowGap={
																							0.8
																						}
																					>
																						{/* Distributor title and score */}
																						<Grid
																							item
																							xs
																						>
																							<Box
																								className="score"
																								component="span"
																							>
																								{`${row.scoreValue} pontos | ${row.name}`}
																							</Box>
																						</Grid>
																						{/* Distributor goal and reached value */}
																						<Grid
																							item
																							container
																							flexDirection="column"
																							justifyContent="center"
																							alignItems="flex-start"
																							xs={
																								12
																							}
																						>
																							<Grid
																								item
																								sx={{
																									width: "100%",
																								}}
																							>
																								<Bar
																									tooltip={`R$ ${row.goalValue.toLocaleString(
																										"pt-BR"
																									)}`}
																									color="#F98561"
																									completed={
																										(row.goalValue /
																											card.highestValue) *
																										100
																									}
																								></Bar>
																							</Grid>
																							<Grid
																								item
																								sx={{
																									width: "100%",
																								}}
																							>
																								<Bar
																									tooltip={`R$ ${row.value.toLocaleString(
																										"pt-BR"
																									)}`}
																									color="#55B6EB"
																									completed={
																										(row.value /
																											card.highestValue) *
																										100
																									}
																								></Bar>
																							</Grid>
																						</Grid>
																					</Grid>
																				)
																		  )
																		: null}
																</Grid>
															</Grid>
															{card?.scale
																?.length && (
																<Grid
																	item
																	container
																	flexDirection="column"
																	justifyContent="center"
																	rowGap={0.5}
																	xs
																>
																	<Divider />
																	<Grid
																		container
																		flexDirection="row"
																		justifyContent="space-between"
																		alignItems="center"
																	>
																		{card?.scale?.map(
																			(
																				item,
																				index
																			) => (
																				<Grid
																					key={
																						index
																					}
																					item
																					container
																					xs
																					flexDirection={
																						index ===
																						2
																							? "row-reverse"
																							: "row"
																					}
																				>
																					<Box
																						component="span"
																						sx={{
																							fontWeight:
																								"400",
																							color: "#D3D3D3",
																						}}
																					>
																						{item.toLocaleString(
																							"pt-BR"
																						)}
																					</Box>
																				</Grid>
																			)
																		)}
																	</Grid>
																</Grid>
															)}
														</Grid>
													)}
												</Grid>
											</Grid>
										</Card>
									</Grid>
								))}
							</Grid>
						)}
					</Grid>
				</LayoutWrapper>
			</div>
		</div>
	);
}

OpportunitiesMobile.defaultProps = {
	app: null,
	config: {},
};

OpportunitiesMobile.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default OpportunitiesMobile;
